module.exports = __webpack_public_path__ + "static/media/minus-square.4573b37c.svg";